import $ from "jquery";
import { Klass, u_ } from "@pressmedia/webappbase";
import vuwer from "@pressmedia/vuwer";

vuwer.appendKlass("VuwPager", {
	_defaultOptions: {
		currentPage: 1,
		baseUrl: location.origin + location.pathname,
		pageQuery: "page",
		
		createTemplate() {
			return $("<nav/>").addClass("vuw-pager").append(
				$("<header/>").addClass("title").append(
					$("<var/>").attr("data-echo", "total"),
					$("<var/>").attr("data-echo", "from"),
					$("<var/>").attr("data-echo", "to")
				),
				$("<ul/>").addClass("page-list")
			);
		}
	},
	
	/**
	 * [コンストラクタ]
	 * @param {Object} [opt]
	 * @returns this
	 */
	_initialize(opt) {
		u_.isObject(opt) || (opt = {});
		opt = { ...this._defaultOptions, ...opt };
		return Klass("VuwPager").parent._initialize.call(this, opt);
	},
	
	/**
	 * リンク要素の生成関数
	 *
	 * @param {Integer} page
	 * @param {Object} fltr
	 * @returns $Object
	 */
	_createPagerLink(page, fltr) {
		if(!page || page === 1) {
			delete fltr[this.pageQuery];
		} else {
			fltr[this.pageQuery] = page;
		}
		
		return $("<a/>").addClass("change-state").attr({
			href: this.baseUrl + u_.createQueryString(fltr)
		});
	},
	
	// **** render ****
	render($elm, state) {
		if( !u_.isNumber(state.total) || state.total <= 0 ) {
			return $elm.empty().addClass("is-empty");
		}
		
		// [title]
		const $title = $elm.children(".title");
		$title.children("var[data-echo]").each((i, elm) => {
			const $elm = $(elm);
			const k = $elm.data("echo");
			
			if( u_.isNumber(state[k]) ) {
				$elm.replaceWith( $("<span/>").addClass(k).text(state[k]) );
			} else {
				$elm.remove();
			}
		});
		
		// [list]
		const $list = $elm.children(".page-list");
		if( u_.isNumber(state.length) && state.length > 1 ) {
			const children = [];
			u_.isNumber(state.current) || (state.current = 1);
			u_.isObject(state.fltr) || (state.fltr = {});
			
			if( u_.isNumber(state.limit) && state.limit > 0 ) {
				// [pager numbers]
				u_.isNumber(state.start) || (state.start = 0);
				
				let len = state.start + state.limit;
				(len > state.length) && (len = state.length);
				
				for(let i = state.start; i < len; i++) {
					const page = i + 1;
					let $pager;
					
					if(page === state.current) {
						$pager = $("<span/>").addClass("pager-current");
					} else {
						$pager = this._createPagerLink(page, state.fltr);
					}
					
					$pager.addClass("pager-num").append(
						$("<span/>").text(page)
					);
					
					children.push( $("<li/>").attr("data-page", page).append($pager) );
				}
			}
			
			// [pager shift]
			// prev
			const prevPage = state.current - 1;
			let $prev;
			if(prevPage > 0) {
				$prev = this._createPagerLink(prevPage, state.fltr);
			} else {
				$prev = $("<span/>").addClass("pager-none");
			}
			
			$prev.addClass("pager-shift").attr({
				"data-shift": "prev"
			}).html(state.prevElm || "<span>prev</span>");
			
			children.unshift( $("<li/>").attr("data-page", prevPage).append($prev) );
			
			// next
			const nextPage = state.current + 1;
			let $next;
			if(nextPage <= state.length) {
				$next = this._createPagerLink(nextPage, state.fltr);
			} else {
				$next = $("<span/>").addClass("pager-none");
			}
			
			$next.addClass("pager-shift").attr({
				"data-shift": "next"
			}).html(state.nextElm || "<span>next</span>");
			
			children.push( $("<li/>").attr("data-page", nextPage).append($next) );
			
			// [append DOM tree]
			$list.append(...children);
			
		} else {
			$list.remove();
			$elm.addClass("has-none");
		}
		
		return $elm;
	}
});
